/* Built In Imports */

/* External Imports */
import { Box,Image } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
import MidContainer from '@Layout/MidContainer';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import GoogleMap from '@components/Embeds/GoogleMap';
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextContent from '@components/UI/StructuredTextContent';

/* Services */

const HowtoReach = ({ section, region, lang }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const sectionContent = section?.sectionContent;

  return (
    <>
      <SectionTitle titleObj={sectionContent[0]} />
      <MidContainer>
        <Box display={{ base: 'block', md: 'flex' }} mb="30px">
          <Box
            maxW={{ base: '100%', md: '360px' }}
            mr={{ base: '0', md: '70px' }}
            pt={{ base: '20px', md: '2%' }}
            pb="30px"
            m={{ base: '0 16px', md: '0 auto' }}
            className="event-text"
          >
            {StructuredTextContent(section?.sectionContent[2]?.body)}
            {!isMobile && sectionContent[3] && (
            <Box display="flex" justifyContent="center" alignItems="center">
              <Image
                src={sectionContent[3]?.image?.url}
                alt={sectionContent[3]?.image?.alt}
                title={sectionContent[3]?.image?.title}
                margin="0 10px"
              />
              <Image
                src={sectionContent[4]?.image?.url}
                alt={sectionContent[4]?.image?.alt}
                title={sectionContent[4]?.image?.title}
                margin="0 10px"
              />
            </Box>
          )}
          </Box>
          <Box width={{ base: '100%', md: '510px' }}>
            <GoogleMap sectionContent={sectionContent[1]} ht="280px" />
          </Box>
          {isMobile && sectionContent[3] && (
            <Box display="flex" justifyContent="center" alignItems="center">
            <Image
              src={sectionContent[3]?.image?.url}
              alt={sectionContent[3]?.image?.alt}
              title={sectionContent[3]?.image?.title}
              margin="0 10px"
            />
            <Image
              src={sectionContent[4]?.image?.url}
              alt={sectionContent[4]?.image?.alt}
              title={sectionContent[4]?.image?.title}
              margin="0 10px"
            />
            </Box>
          )}
        </Box>
      </MidContainer>
    </>
  );
};

export default HowtoReach;
